import React from "react";
import { useTranslation } from "react-i18next";

// icon
import close from "../../../../assets/images/pages/Products/ProdForm/close.svg";

export const Error = (props) => {
  const { t } = useTranslation();
  const { onClose } = props;

  return (
    <div className="modal-window-notification-error-modal">
      <div className="close-div" onClick={onClose}>
        <p>{t("createProd.closeLabel")}</p>
        <img src={close} alt="" />
      </div>
      <p>{t("Виникла серверна помилка...")}</p>
      <div className="buttons">
        <button onClick={onClose} className="danger">
          <span>{t("OK")}</span>
        </button>
      </div>
    </div>
  );
};
